import { useMemo } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Formik } from "formik";
import validationSchema from "./index.schema";
import AppInputField from "components/shared/FormComponents/AppInputField";
import LoadingButton from "components/shared/LoadingButton";
import { successMessageToast } from "helpers/common";
import { useCreateRecommendationTemplateMutation } from "store/services/clients/reports-v2/recommendationTemplates";
import close from "../../../Assets/images/cross_icon.png"
// css
import styles from "./index.module.scss";
import CKEditorField from "components/CkEditor/CkEditor";
import { RequiredFieldAstrick } from "components/Common/Common";
import CustomEditor from "components/TipTapEditor/CustomeEditor";

const SaveRecommendationTemplatePop = ({ showPopup, closePopup, data, clientType, assessmentId }) => {
  const [createTemplate] = useCreateRecommendationTemplateMutation();
  const [updateTemplate] = useCreateRecommendationTemplateMutation();

  const editMode = !!data?.id;

  const initialValues = useMemo(() => {
    return {
      title: data?.title || "",
      answers: data?.answers || "",
    }
  }, [data, assessmentId]);

  const handleSubmit = async (values) => {
    try {
      if (data?.id) {
        await updateTemplate({ id, clientType, values }).unwrap();
      }
      await createTemplate({ clientType, values }).unwrap();
      successMessageToast("Template saved successfully");
      closePopup();
    } catch (err) {
      console.error("Error saving recommendation template", err);
    }
  }

  return (
    <Modal
      show={showPopup}
      className={`${styles.AddNewGoalPop} modal-v2 AddNewGoalPop`}
      onHide={closePopup}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleSubmit,
            setFieldValue,
            isSubmitting,
            errors,
            values,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="reports-v2">
                <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                  <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{editMode ? "Edit TEMPLATES" : "SAVE TO TEMPLATES"}</h6>
                  <img onClick={closePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                </div>
                <Row >
                  <Col md="9" className="my-2 name-input-v2">
                    <label
                      htmlFor=""
                      className="discharge-screen-label mt-0"
                    >
                      Name
                      <RequiredFieldAstrick />
                    </label>
                    <AppInputField
                      name="title"
                      className={`${styles.formControl} readonly-box h-auto`}
                      styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                      placeholder="Enter recommendation name"
                    />
                  </Col>
                  <Col md="12" className="my-2">
                    <label
                      htmlFor=""
                      className="discharge-screen-label mt-0"
                    >
                      Description
                      <RequiredFieldAstrick />
                    </label>
                    <div className="editor-paren-v2">
                      <CustomEditor style={{ borderRadius: 0 }} name={`answers`} />
                    </div>
                    {/* <CKEditorField
                        items={[
                          'bold',
                          'italic',
                          'underline',
                          'alignment',
                          '|',
                          'bulletedList',
                          'numberedList',
                        ]}
                        value={values?.answers}
                        handleChange={(event, editor) => {
                          setFieldValue(`answers`, editor?.getData());
                        }}
                      /> */}
                  </Col>
                </Row>
              </div>
              <div className="btnWrpper mt-2 text-end d-flex justify-content-end">
                <LoadingButton
                  type="submit"
                  className="blue-btn"
                  isLoading={isSubmitting}
                >
                  Save to Templates
                </LoadingButton>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default SaveRecommendationTemplatePop;
